import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import ShopSellers from "../components/shops/ShopSellers";
import Pagination from "../components/Pagination";
import { fetchSellers } from "../store/reducers/homeReducer";
import { useDispatch, useSelector } from "react-redux";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
import { LayoutGrid, LayoutList } from "lucide-react";

const Shops = () => {
  const { sellers, totalSellers, parPage } = useSelector((state) => state.home);
  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(1);
  const [styles, setStyles] = useState("grid");
  const [sortPrice, setSortPrice] = useState("all");

  useEffect(() => {
    dispatch(fetchSellers({ sortPrice, pageNumber }));
  }, [sortPrice, pageNumber]);

  return (
    <div>
      <Headers />
      <section
        className="h-[220px] bg-cover bg-no-repeat relative bg-left"
        style={{
          backgroundImage: `url(${process.env.REACT_APP_URL}/images/banner/bannermain.jpg)`,
        }}
      >
        <div className="absolute left-0 top-0 w-full h-full bg-[#0000008a]">
          <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white">
              <h2 className="text-3xl font-bold">Official stores</h2>
              <div className="flex justify-center items-center gap-2 text-2xl w-full">
                <Link to="/">Home</Link>
                <span className="pt-1">
                  <MdOutlineKeyboardArrowRight />
                </span>
                <span>Stores</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-5">
        <div className="w-[80%] md:w-[90%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
          <div className="w-12/12 md-lg:w-12/12 md:w-full">
            <div className="pl-8 md:pl-0">
              <div className="lg-md:py-10 mb-10 rounded-md flex justify-between items-start">
                <h2 className="text-lg font-medium text-white">
                  {totalSellers} Stores
                </h2>
                <div className="flex justify-center items-center gap-3">
                  <Select onValueChange={(value) => setSortPrice(value)}>
                    <SelectTrigger className="w-full">
                      <SelectValue placeholder="Sort By" />
                    </SelectTrigger>
                    <SelectContent className="nex_drop">
                      <SelectItem
                        value="verified"
                        className="hover:text-white cursor-pointer"
                      >
                        Verified stores
                      </SelectItem>
                      <SelectItem
                        value="all"
                        className="hover:text-white cursor-pointer"
                      >
                        All stores
                      </SelectItem>
                    </SelectContent>
                  </Select>
                  <div className="flex justify-center items-start gap-4 md-lg:hidden">
                    <div
                      onClick={() => setStyles("grid")}
                      className={`p-2 ${
                        styles === "grid" && "bg-[#1C1C1C]"
                      } text-white cursor-pointer rounded-sm`}
                    >
                      <LayoutGrid size={18} />
                    </div>
                    <div
                      onClick={() => setStyles("list")}
                      className={`p-2 ${
                        styles === "list" && "bg-[#1C1C1C]"
                      } text-white cursor-pointer rounded-sm`}
                    >
                      <LayoutList size={18} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="pb-8">
                <ShopSellers sellers={sellers} styles={styles} />
              </div>
              <div>
                {totalSellers > parPage && (
                  <Pagination
                    pageNumber={pageNumber}
                    setPageNumber={setPageNumber}
                    totalItem={totalSellers}
                    parPage={parPage}
                    showItem={Math.floor(totalSellers / parPage)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Shops;
